<div mat-dialog-content>
  <div [formGroup]="form" [patchFormGroupValues]="config()">
    <div class="form-row">
      <div class="form-group col-lg-10">
        <ng-select
          [items]="companies$ | async"
          bindLabel="name"
          bindValue="id"
          [multiple]="false"
          appendTo="body"
          [clearable]="false"
          formControlName="companyId"
          placeholder="{{ 'load-profile.fields.COMPANY' | transloco }}"
        >
        </ng-select>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-10">
        <ng-select
          [items]="layoutOptions"
          [multiple]="false"
          appendTo="body"
          [clearable]="false"
          formControlName="layout"
          placeholder="{{ 'widgetType-MarketCustomerAnalysis.layout' | transloco }}"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ getLayoutLabelKey(item) | transloco }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ getLayoutLabelKey(item) | transloco }}
          </ng-template>
        </ng-select>
      </div>
    </div>
  </div>
</div>
